<template>
    <div>
        <el-upload action="/api/requests/files/upload"
                   list-type="picture-card"
                   :file-list="startFileList"
                   :on-success="onSuccess"
                   :on-remove="handleRemove"
                   multiple
                   :accept="accept"
                   :limit="limit"
                   :on-exceed="handleExceed"
                   :disabled="disabledUpload"
        >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{file}">
            <el-progress
                v-if="file.status === 'uploading'"
                type="circle"
                :stroke-width="6"
                :percentage="parseInt(file.percentage, 10)">
            </el-progress>
                <UploadCard :file="file" />
                <template v-if="(file.response !== undefined ? file.response.toLowerCase().indexOf('.pdf') !== -1 : file.url.toLowerCase().indexOf('.pdf') !== -1)">
                    <img v-if="file.status !== 'uploading'" class="el-upload-list__item-thumbnail"  :data-pdf-thumbnail-file="file.response !== undefined ? file.response : file.url" src="" alt="">
                </template>
                <template v-else-if="file.response !== undefined ? file.response.toLowerCase().indexOf('.jpg') !== -1 || file.response.toLowerCase().indexOf('.jpeg') !== -1 || file.response.toLowerCase().indexOf('.png') !== -1 || file.response.toLowerCase().indexOf('.gif') !== -1 : file.url.toLowerCase().indexOf('.jpg') !== -1 || file.url.toLowerCase().indexOf('.jpeg') !== -1 || file.url.toLowerCase().indexOf('.png') !== -1 || file.url.toLowerCase().indexOf('.gif') !== -1">
                    <img v-if="file.status !== 'uploading'" class="el-upload-list__item-thumbnail"  :src="file.url" alt="">
                </template>
            <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleDownload(file)">
                      <i class="el-icon-download"></i>
                    </span>
                    <span v-if="!disabledRemove" class="el-upload-list__item-delete" @click="handleRemove(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                </span>

        </div>
        </el-upload>
        <el-dialog width="70%" top="3vh" :visible.sync="dialogVisible" :append-to-body="true">
            <div class="d-flex justify-content-center pb-5">
                <button @click.prevent="previewCard" class="btn btn-light"> <i class="fas fa-chevron-left"></i> </button>
                <a class="btn btn-light mx-5" target="_blank" :href="dialogImageUrl"><i class="fas fa-download"></i> Скачать</a>
                <button @click.prevent="nextCard" class="btn btn-light"> <i class="fas fa-chevron-right"></i> </button>
            </div>
            <template v-if="dialogImageUrl.toLowerCase().indexOf('.pdf') !== -1">
                <VuePdfEmbed :textLayer="true" :source="dialogImageUrl" />
            </template>
            <template v-else-if="dialogImageUrl.toLowerCase().indexOf('.jpg') !== -1 || dialogImageUrl.toLowerCase().indexOf('.jpeg') !== -1 || dialogImageUrl.toLowerCase().indexOf('.png') !== -1 || dialogImageUrl.toLowerCase().indexOf('.gif') !== -1">
                <img width="100%" :src="dialogImageUrl" alt="">
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
    import UploadCard from "./UploadCard.vue";
    export default {
        name: "DocumentsUpload",
        components: {UploadCard, VuePdfEmbed},
        props: {
            filesModel: {
                type: Array,
                default() {
                    return []
                },
            },
            accept: {
                type: String,
                default: "image/*"
            },
            limit: {
                type: Number,
                default() {
                    return 3;
                }
            },
            disabledUpload: {
                type: Boolean,
                default() {return false},
            },
            disabledRemove: {
                type: Boolean,
                default() {return false},
            }
        },
        data: () => ({
            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            startFileList: [],
            lastFilesModel: [],
            // files: [],
        }),
        mounted() {
            // this.files = (this.filesModel ? this.filesModel : []);
            this.lastFilesModel = this.filesModel;
            this.startFileList = this.makeCollectionFromArray(this.filesModel ? this.filesModel : []);
            setTimeout(() => {
                createPDFThumbnails();
            }, 300);
        },
        computed: {
            files: {
                get () { return this.filesModel },
                set (value) { this.$emit('update:filesModel', value) },
            }
        },
        watch: {
            filesModel: function (val) {
                // Если есть разница то генерируем новую коллекцию стартофых фоток
                if (!_.isEqual(this.lastFilesModel, val))  {
                    this.startFileList = this.makeCollectionFromArray(val);
                }

                this.lastFilesModel = val;
                setTimeout(() => {
                    createPDFThumbnails();
                }, 300);
            },
        },
        methods: {
            makeCollectionFromArray(arr) {
                return arr
                    .map(function (item) {
                        return {name: "", url: item}
                    });
            },
            handleRemove(file) {
                let self = this;
                this.$confirm('Удалить файл?', {
                    confirmButtonText: 'Да',
                    cancelButtonText: 'Отмена',
                    type: 'warning'
                }).then(() => {
                    let files = this.files = _.filter(this.files, function (item) {
                        let url = file.response ? file.response : file.url;
                        return item !== url;
                    });
                    self.startFileList = _.map(files, function (item) {
                        return {name: "", url: item};
                    });
                    self.$emit('change');
                    self.$emit('remove');
                });
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.response !== undefined ? file.response : file.url;
                this.dialogVisible = true;
            },
            handleDownload(file) {
                this.forceFileDownload(file);
            },
            onSuccess(response, file, fileList) {
                this.files.push(response);
                this.$emit('change');
                this.$emit('add');
                setTimeout(() => {
                    createPDFThumbnails();
                }, 300);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`Лимит загруженных файлов - ${this.limit}`);
            },

            forceFileDownload(file) {
                const url = file.url;
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.name);
                document.body.appendChild(link);
                link.click();
            },
            http(option) {
                console.log(option);
                const formData = new FormData();

                if (option.data) {
                    Object.keys(option.data).forEach(key => {
                        formData.append(key, option.data[key]);
                    });
                }
                formData.append('file', option.file);
                console.log(formData);

                return axios({
                    method: 'post',
                    url: option.action,
                    data: formData,
                });
            },
            previewCard() {
                let current_index = this.files.indexOf(this.dialogImageUrl);
                let preview_index = 0;
                if (current_index !== -1) {
                    if (this.files[current_index - 1]) {
                        preview_index = current_index - 1;
                    }
                }
                this.dialogImageUrl = this.files[preview_index];
            },
            nextCard() {
                let current_index = this.files.indexOf(this.dialogImageUrl);
                let next_index = 0;
                if (current_index !== -1) {
                    if (this.files[current_index + 1]) {
                        next_index = current_index + 1;
                    }
                }
                this.dialogImageUrl = this.files[next_index];
            }
        }
    }
</script>

<style scoped>

</style>
